/*global swal*/
import './style.less';
import { keyBy, orderBy, uniqBy } from 'lodash';

export default function($log, $stateParams, $q, CategoryClass, ApiClass, EventClass, CoursesClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.profile_uid = $stateParams.id;
  vm.loaded = false;

  const courses = [];

  vm.deliveryGroup = [];
  vm.deliveryFilter = '';
  vm.typeFilter = 'internal';
  vm.courses = [];

  vm.isCourse = course => CoursesClass.isCourse(course);

  vm.activateCourse = function(course) {
    const updatedCourse = { course_id: course.course_id, active: true };
    return ApiClass.coursesIdPatch({ id: course.course_id, manage: true }, { course: updatedCourse })
      .then(() => {
        course.active = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.deactivateCourse = function(course) {
    const updatedCourse = { course_id: course.course_id, active: false };
    return ApiClass.coursesIdPatch({ id: course.course_id, manage: true }, { course: updatedCourse })
      .then(() => {
        course.active = false;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.setCourseAccess = function(course) {
    if (course.inviteOnly) return (course.access = 'Invite Only');
    if (course.firmOnly) return (course.access = 'Firm Only');
    return (course.access = 'Open');
  };

  vm.updateAccess = function(course) {
    const firmOnly = course.access === 'Firm Only' ? true : false;
    const inviteOnly = course.access === 'Invite Only' ? true : false;
    const updatedCourse = { course_id: course.course_id, firmOnly, inviteOnly };
    course.accessOpen = false;
    return ApiClass.coursesIdPatch({ id: course.course_id, manage: true }, { course: updatedCourse })
      .then(() => {
        course.inviteOnly = inviteOnly;
        course.firmOnly = firmOnly;
        vm.setCourseAccess(course);
        course.accessOpen = false;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.setFilters = () => {
    vm.deliveryGroup = uniqBy(courses || [], 'delivery_method').map(({ delivery_method }) => delivery_method);

    vm.courses.length = 0;

    const filteredCourses = courses.filter(({ type, delivery_method }) => {
      if (vm.typeFilter && type !== vm.typeFilter) return false;

      if (typeof vm.deliveryFilter === 'number' && delivery_method !== vm.deliveryFilter) return false;

      return true;
    });

    vm.courses.push(...filteredCourses);
  };

  function activate() {
    const qArr = [
      CategoryClass.loadCategories(),
      ApiClass.coursesGet({ courseType: 'internal' }, {}, { queryParams: { manage: true, 'filter:basic': true } })
    ];

    $q.all(qArr)
      .then(([categories, coursesReponse]) => {
        let rawCourses = coursesReponse.data.courses;

        rawCourses.forEach(vm.setCourseAccess);

        vm.course_dict = keyBy('event_id', rawCourses);
        vm.Categories = categories.obj;
        vm.tooltipMsg = { true: 'This course is active, it can be taken by users. Click to deactivate course.' };
        vm.tooltipMsg.false = 'This course is not active, it can not be taken by users. Click to activate course.';
        rawCourses = rawCourses.filter(course => {
          course.hideAccess = EventClass.isEvent(course);
          return course.approval;
        });

        courses.push(...orderBy(rawCourses, ['name', 'delivery_method'], ['asc', 'asc']));

        vm.setFilters();

        vm.loaded = true;
      })
      .catch(error => {
        vm.loaded = true;
        vm.error.status = true;
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/courses/get/index.js